export default __webpack_public_path__ + "static/SpotLight-445c0131c7a7d7348fdff53cf9d380e0.png";